import Vue from 'vue'
import Router from 'vue-router'
import Profile from '@/page/Profile'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Profile',
      component: Profile
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js